// @flow
import * as React from 'react';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import withContextLog, { type ContextLog } from 'app/common/lib/react/deprecated/withContextLog'; // eslint-disable-line pinterest/no-deprecated-imports

type Props = {
  contextLog: ContextLog,
  objectId: string,
  onAfterOpen?: () => void,
  onHide?: () => void,
};

function PincodeModal({ contextLog, objectId, onAfterOpen, onHide, ...props }: Props) {
  const contextLogData = {
    component: PCONST.thrift.ComponentType.MODAL_PINCODE,
    objectId,
  };
  return (
    <LegacyModal
      {...props}
      onAfterOpen={() => {
        if (onAfterOpen) {
          onAfterOpen();
        }
        contextLog(PCONST.thrift.EventType.OPEN_MODAL, contextLogData);
      }}
      onHide={() => {
        if (onHide) {
          onHide();
        }
        contextLog(PCONST.thrift.EventType.HIDE_MODAL, contextLogData);
      }}
    />
  );
}

export default withContextLog(PincodeModal);
